export const START_SNAKE = [
    [1, 1],
];

export const SPEED = 200;

export const DIR = {
    37: [-1, 0],
    38: [0, -1],
    39: [1, 0],
    40: [0, 1]
};

export const X_MAX = 69;
export const Y_MAX = 29;
